import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, User as UserIcon, Loader2, Shield } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/auth";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) {
      toast.error("Introduce usuario y contraseña");
      return;
    }
    setLoading(true);
    try {
      await api.post("/admin/login", { username: username.trim(), password });
      await refresh();
      toast.success("Acceso admin concedido");
      navigate("/admin");
    } catch (e) {
      const msg = e?.response?.data?.detail || "No se pudo iniciar sesión";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen-safe bg-obsidian text-white flex items-center justify-center px-6"
      data-testid="admin-login-page"
    >
      <form
        onSubmit={submit}
        className="glass-card rounded-md p-8 sm:p-10 max-w-md w-full"
        autoComplete="off"
      >
        <div className="mb-6 flex justify-center"><Logo /></div>
        <div className="flex items-center justify-center gap-2 mb-2">
          <Shield className="w-4 h-4 text-gold" />
          <span className="font-label text-gold uppercase tracking-widest text-xs">Acceso admin</span>
        </div>
        <h1 className="font-display text-3xl text-gold-light text-center mb-8">
          Panel restringido
        </h1>

        <label className="font-label text-faded block mb-2">Usuario</label>
        <div className="relative mb-4">
          <UserIcon className="w-4 h-4 text-faded absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="text"
            className="input-field pl-10"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="off"
            data-testid="admin-username"
            autoFocus
          />
        </div>

        <label className="font-label text-faded block mb-2">Contraseña</label>
        <div className="relative mb-6">
          <Lock className="w-4 h-4 text-faded absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="password"
            className="input-field pl-10"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            data-testid="admin-password"
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="btn-gold w-full justify-center"
          data-testid="admin-login-submit"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Shield className="w-4 h-4" />}
          {loading ? "Comprobando…" : "Entrar al panel"}
        </button>
      </form>
    </div>
  );
}
